<div id="result" class="page-layout simple">
    <div class="content p-4">
        <div fxLayout="column" fxLayoutAlign="center">
            <div class="courses" fxLayout="row wrap" fxLayoutAlign="center" [@animateStagger]="{value:'50'}">
                <div class="course" fxFlex="100" [ngClass]="'web'" [@animate]="{value:'*',params:{y:'100%'}}" *ngIf="resultCheck">
                    <mat-expansion-panel [expanded]="true"  class="course-content" fxLayout="column" fxFlex="1 1 auto">
                        <mat-expansion-panel-header class="header web-bg" style="height: auto">
                            <div fxLayout="row wrap" fxLayoutAlign="center" style="width: 100% !important; color: white">
                                <div class="length" fxFlex="100" fxLayoutAlign="start center" fxLayout="row">
                                    <button mat-icon-button style="background: white; color: #2196f3 !important" class="length-icon s-20" [routerLink]="'/landingpage/home2'">
                                        <mat-icon>arrow_back</mat-icon>
                                    </button>
                                    <div class="min">Search Info</div>
                                </div>
                                <div fxFlex="100" fxFlex.gt-xs="50" fxFlex.gt-md="25">
                                    <div fxLayout="column" fxFlex="1 1 auto" fxLayoutAlign="center center">
                                        POL: {{search.pol}}
                                    </div>
                                </div>
                                <div fxFlex="100" fxFlex.gt-xs="50" fxFlex.gt-md="25">
                                    <div fxLayout="column" fxFlex="1 1 auto" fxLayoutAlign="center center">
                                        POD: {{search.pod}}
                                    </div>
                                </div>
                                <div fxFlex="100" fxFlex.gt-xs="50" fxFlex.gt-md="25">
                                    <div fxLayout="column" fxFlex="1 1 auto" fxLayoutAlign="center center">
                                        Date: {{search.etd}}
                                    </div>
                                </div>
                                <div fxFlex="100" fxFlex.gt-xs="50" fxFlex.gt-md="25">
                                    <div fxLayout="column" fxFlex="1 1 auto" fxLayoutAlign="center center">
                                        Type: {{search.type}}
                                    </div>
                                </div>
                            </div>

                        </mat-expansion-panel-header>
                        <home-result></home-result>

                        <div class=" w-100-p" style="max-width: 100%" *ngIf="doSearch && resultLength == 0">

                          <div class="p-16">
                              <div class="h1">0 result was found!</div>
                          </div>

                          <div class="p-16 pt-0 line-height-1.75">
                              Online facebook and contact us by messeage on bottom to get more info.
                          </div>

                        </div>
                    </mat-expansion-panel>
                </div>
                <div id="map" class="course" fxFlex="100" [ngClass]="'web'" [@animate]="{value:'*',params:{y:'100%'}}" >
                    <mat-expansion-panel [expanded]="true"  class="course-content" fxLayout="column" fxFlex="1 1 auto">

                        <mat-expansion-panel-header class="header" fxLayout="row" fxLayoutAlign="center center"
                             [ngClass]="'web-bg'">
                            <div class="length mr-16" fxLayout="row" fxLayoutAlign="center center">
                                <mat-icon class="length-icon s-20">map</mat-icon>
                                <div class="min">Port to Port Map</div>
                            </div>
                        </mat-expansion-panel-header>
                        <!--
                        <home-map></home-map>
                    -->
                        <agm-map class="h-640 w-100-p"
                            [minZoom]="1"
                            [maxZoom]="20"
                            [fullscreenControl]="false"
                            [rotateControl]="false"
                            [zoomControl]="true"
                            [scaleControl]="true"
                            [streetViewControl]="false"
                            [scrollwheel]="false"
                            [zoom]="6"
                            [usePanning]="true"
                            [latitude]="x" 
                            [longitude]="y"
                            #AgmMap
                            >
                              <agm-marker *ngIf="pol"
                              [latitude]="pol.info.coords.lat"
                              [longitude]="pol.info.coords.lng">

                                <agm-info-window>
                                  <strong>{{pol.name}}</strong>
                                </agm-info-window>

                              </agm-marker>
                              <agm-marker *ngIf="pod"
                              [latitude]="pod.info.coords.lat"
                              [longitude]="pod.info.coords.lng">

                                <agm-info-window>
                                  <strong>{{pod.name}}</strong>
                                </agm-info-window>

                              </agm-marker>
                              <ng-container>
                                 <agm-polyline [strokeColor]="'red'" [editable]='true'>
                                  <agm-polyline-point *ngFor="let point of polyline" [latitude]="point.lat" [longitude]="point.lng">
                                  </agm-polyline-point>
                                </agm-polyline>
                              </ng-container>
                        </agm-map>
                    </mat-expansion-panel>

                </div>
            </div>

        </div>

    </div>
    <!-- / CONTENT -->
    <div class="content">
        <div fxLayout="column" fxLayoutAlign="center">
            <div class="courses" fxLayout="row wrap" fxLayoutAlign="center" [@animateStagger]="{value:'50'}">
                <div class="course" *ngFor="let item of shortcut" fxFlex="100" fxFlex.gt-xs="50"
                     fxFlex.gt-md="33" [ngClass]="'web'" [@animate]="{value:'*',params:{y:'100%'}}">

                    <div class="course-content" fxLayout="column" fxFlex="1 1 auto">

                        <div class="header-item" fxLayout="row" fxLayoutAlign="center center"
                             [ngClass]="'web-bg'">

                            <div class="category" fxFlex>
                                {{item[0].pol.name}} to {{item[0].pod.name}}
                            </div>
                        </div>
                        <div class="content" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                            <div *ngFor="let fcl of item; let i = index">
                                <div *ngIf="i<3">
                                    <span class="updated">OCEAN FREIGHT </span>
                                    <span class="h1" style="color: blue">{{fcl.amount | number:(fcl.currency.code == 'VND' ? '1.0-0' : '1.2-2')}} {{fcl.currency.code}} </span>
                                    <span class="updated">per {{fcl.unit.code}}</span>
                                </div>
                            </div>
                            <div class="updated mt-8">Validity: {{item[0].validity | date: 'MM/dd/yyyy'}}</div>
                        </div>

                        <div class="footer" fxLayout="row" fxLayoutAlign="end center">
                            <button mat-button color="accent" (click)="getResultByShortcut(item)">
                                Direct service
                            </button>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
